<template>
  <transition-group name="op-animate" tag="div">
    <div key="edit-container" v-if="issuesList.length">
      <div class="edit-container">
        <transition name="slide" mode="out-in">
          <div :key="'general'" v-if="mode === 'general'" class="general-box">
            <ct-button
              type="secondary"
              size="mini"
              :disabled="!loadingDown"
              @click="changeOrder">
              Add time
              <ct-icon class="rotate-icon" name="paixu" :class="{'is-rotate': order === 0}" :multi-color="true"></ct-icon>
            </ct-button>
            <ct-button
              type="secondary"
              @click="toggleEditMode"
              size="mini">
              Edit
            </ct-button>
          </div>
          <div :key="'edit'" v-else class="edit-box">
            <ct-button @click="checkAll" size="mini" type="text_secondary">
              <ct-icon :name="chooseAllName"></ct-icon>
              Check all
            </ct-button>
            <ct-button @click="delALl" :disabled="!choosedLen" size="mini" type="text_secondary">
              <ct-icon name="delete"></ct-icon>
              Delete in batches
            </ct-button>
            <ct-button size="mini" type="secondary"  @click="toggleEditMode">
              Exit edit mode
            </ct-button>
          </div>
        </transition>
      </div>
      <div class="issues-container">
        <ul class="issues-table-thead">
          <li>
            <span style="flex:283;">Title</span>
            <span style="flex:85;">ID</span>
            <span style="flex:157;">Add time</span>
            <span style="flex:113;">Source</span>
            <span style="flex:72;"></span>
          </li>
        </ul>
        <ul class="issues-table-tbody"
          :class="{
            'edit-mode': mode === 'edit',
            'general-mode': mode === 'general',
          }">
          <li
            v-for="el in issuesList"
            :key="el.question_id"
            @click="clickLi(el)"
            :class="{choosed: el.choosed && mode === 'edit'}">
            <span style="flex:283;">{{ el.text }}</span>
            <span style="flex:85;">{{ el.question_id }}</span>
            <span style="flex:157;">{{ moment(el.created_at * 1000).format('HH:mm DD/MM/YYYY') }}</span>
            <span style="flex:113;">{{ el.type === 2 ? 'question bank' : el.type === 1 ? 'test' : 'light course' }}</span>
            <span style="flex:72;">
              <span @click.stop="deleteIssue(el.question_id)" class="delete-part" v-show="mode === 'edit'">
                <ct-icon name="delete"></ct-icon>
                Delete
              </span>
            </span>
            <div class="choosed-symbol" v-show="mode==='edit' && el.choosed">
              <ct-icon class="choosed-symbol-icon" name="check" style="color: #000;font-size: 12px;"></ct-icon>
            </div>
          </li>
        </ul>
        <h5 class="issues-tips" v-show="!stillHasMore">--- No more questions ---</h5>
      </div>
    </div>
    <div key="empty-image-container" v-else class="empty-image-container">
      <img src="@/assets/img/comet/issueList/cuokong@2x.png" alt="">
      <h5>no question collection in this chapter.</h5>
    </div>
  </transition-group>
</template>

<script>
import api from '../../../api'
import moment from 'moment'
export default {
  name: 'IssueListSub',
  props: {
    id: Number
  },
  data () {
    return {
      mode: 'general',
      issuesList: [],
      modeDown: true,
      loadingDown: true,
      total: 0,
      current_page: 1,
      order: 1,
      checkMode: false,
      hasDel: false
    }
  },
  methods: {
    moment,
    toggleEditMode () {
      if (!this.modeDown) return
      this.modeDown = false
      if (this.mode === 'general') {
        this.mode = 'edit'
      } else {
        if (this.hasDel) {
          this.issuesList = []
          this.current_page = 1
          this.total = 0
          this.getList()
          this.hasDel = false
        } else {
          this.issuesList = this.formatData(this.issuesList)
        }
        this.mode = 'general'
      }
      setTimeout(() => {
        this.modeDown = true
      }, 300)
    },
    changeOrder () {
      if (this.loadingDown) {
        this.order = this.order === 1 ? 0 : 1
      } else {}
    },
    formatData (data) {
      let a = JSON.parse(JSON.stringify(data))
      a.forEach((el, index) => {
        a[index].choosed = false
      })
      return a
    },
    clickLi (el) {
      let a = this.issuesList.findIndex((i) => {
        return i.question_id === el.question_id
      })
      if (this.mode === 'general') {
        if (!el.online) {
          this.$toast({
            message: 'This problem\'s status is offline yet',
            type: 'warning'
          })
          return
        }
        this.$router.push({
          name: 'questionDetail',
          params: {
            origin: this.id,
            index: a
          }
        })
      } else {
        this.issuesList[a].choosed = !this.issuesList[a].choosed
      }
    },
    getList () {
      if (!this.loadingDown) return
      this.loadingDown = false
      api.getWrongQuestionList({
        params: {
          parent_id: this.id,
          current_page: this.current_page,
          order: this.order
        }
      }).then(res => {
        let data = res.data
        if (data.code === 1) {
          data = data.data
          if (!data.list || !data.list.length) {
            this.current_page -= 1
          }
          let arr = data.list || []
          arr = this.formatData(arr)
          this.issuesList = this.issuesList.concat(arr)
          this.total = data.total
        } else {
          this.current_page -= 1
        }
        this.loadingDown = true
      })
    },
    checkAll () {
      this.checkMode = !this.checkMode
      this.issuesList.forEach(el => {
        el.choosed = this.checkMode
      })
    },
    scroll () {
      if (document.scrollingElement.scrollTop + window.innerHeight >= document.body.offsetHeight) {
        if (this.stillHasMore && this.mode === 'general') {
          this.current_page += 1
          this.getList()
        }
      }
    },
    delALl () {
      let ids = []
      this.issuesList.forEach(el => {
        if (el.choosed) {
          ids.push(el.question_id)
        }
      })
      this.deleteIssue(ids)
    },
    deleteIssue (id) {
      const a = id instanceof Array
      let message
      let data
      if (a) {
        data = id
        message = 'Are you sure to delete the ' + id.length + ' questions has been choosed from the collection ?'
      } else {
        message = 'Are you sure to delete the question which id is \' ' + id + '  \' from the collection ?'
        data = [id]
      }
      this.$confirm({
        title: '',
        message,
        cancelButton: true,
        cancelButtonText: 'Cancel',
        handleAction: (confirm, resolve, reject) => {
          if (confirm) {
            this.confirmDel(data).then(res => {
              if (res.code === 1) {
                this.$toast({
                  message: 'Successfully delete the question',
                  type: 'success'
                })
                if (a) {
                  this.mode = 'general'
                  this.hasDel = false
                  this.issuesList = []
                  this.current_page = 1
                  this.total = 0
                  this.getList()
                } else {
                  const c = this.issuesList.findIndex(el => {
                    return el.question_id === id
                  })
                  this.issuesList.splice(c, 1)
                }
                this.$emit('hasDelete')
                resolve()
              } else {
                this.$toast({
                  message: 'Delete faild',
                  type: 'error'
                })
                resolve()
              }
            }, err => {
              this.$toast({
                message: 'Delete faild',
                type: 'error'
              })
              console.log(err.error)
            })
          }
        }
      })
    },
    confirmDel (id) {
      return new Promise((resolve, reject) => {
        api.deleteWrongQuestions({
          data: {
            question_ids: id
          }
        }).then(res => {
          let data = res.data
          if (data.code === 1) {
            this.hasDel = true
            resolve(data)
          } else {
            reject(data)
          }
        })
      })
    }
  },
  mounted () {
    this.getList()
    window.addEventListener('scroll', this.scroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scroll)
  },
  computed: {
    choosedLen () {
      let a = 0
      this.issuesList.forEach(el => {
        if (el.choosed) a += 1
      })
      return a
    },
    chooseAllName () {
      return this.choosedLen === this.issuesList.length ? 'yigouxuan' : 'weigouxuan'
    },
    stillHasMore () {
      return this.total > this.issuesList.length
    }
  },
  watch: {
    id (newVal, oldVal) {
      if (newVal === oldVal) return
      this.mode = 'general'
      this.issuesList = []
      this.current_page = 1
      this.total = 0
      this.order = 1
      this.getList()
    },
    chooseAllName (newVal, oldVal) {
      this.checkMode = newVal === 'yigouxuan'
    },
    order (newVal, oldVal) {
      this.mode = 'general'
      this.issuesList = []
      this.current_page = 1
      this.total = 0
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
  .issue-list-right {
    min-height: 70vh;
    padding: 24px 40px;
    position: relative;
    .edit-container {
      position: relative;
      height: 52px;
      > div {
        display: flex;
        margin-bottom: 20px;
        &.general-box {
          justify-content: space-between;
        }
        &.edit-box {
          justify-content: flex-end;
          >* {
            margin-left: 20px;
          }
        }
      }
      .rotate-icon {
        transform: rotate(0deg);
        &.is-rotate {
          transform: rotate(180deg);
        }
      }

      // animation
      .slide-enter-active, .slide-leave-active {
        transition: all .15s;
        position: absolute;
        width: 100%;
      }
      .slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
      }
    }
    .issues-container {
      .issues-table-thead {
        li {
          display: flex;
          justify-content: space-around;
          padding-left: 39px;
          align-items: center;
          font-size:14px;
          color:rgba(163,177,191,1);
          line-height:32px;
          background:rgba(247,251,255,1);
          border-radius:2px;
          text-align: left;
          span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
      .issues-table-tbody {
        li {
          display: flex;
          justify-content: space-around;
          padding-left: 39px;
          align-items: center;
          font-size:14px;
          color: #1a3d5e;
          line-height:45px;
          background:rgba(247,251,255,1);
          border-radius:2px;
          position: relative;
          margin-top: 16px;
          text-align: left;
          height: 45px;
          border:1px solid rgba(247,251,255,1);
          cursor: pointer;
          overflow: hidden;
          border: 1px solid  #EBEDF2;
          &:hover {
            background: #fff;
            box-shadow: 0px 2px 16px 0px rgba(35, 62, 114, 0.07);
          }
          > span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .delete-part {
            cursor: pointer;
            &:hover {
              color: #37CAD7;
            }
          }
          &.choosed {
            border:1px solid rgba(55,202,215,1);
            cursor: default;
          }
          .choosed-symbol {
            flex: 0;
            position: absolute;
            left: 0;
            top: 0;
            border: 22px solid;
            border-color: #37CAD7 transparent transparent #37CAD7;
            .choosed-symbol-icon {
              position: absolute;
              left: -14px;
              top: -14px;
            }
          }
        }
        &.edit-mode {
          li {
            cursor: default;
          }
        }
      }
      .issues-tips {
        text-align: center;
        margin-top: 50px;
        font-weight: 400;
      }
    }
    .empty-image-container {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
      img {
        width: 142px;
      }
      h5 {
        margin-top: 30px;
        font-size:14px;
        font-weight:400;
        color:rgba(186,196,206,1);
        line-height:14px;
      }
    }

    .op-animate-enter, .op-animate-leave-to {
      opacity: 0;
    }
    .op-animate-enter-active,
    .op-animate-leave-active {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0px;
      top: 0px;
      padding: 24px 40px;
      transition: opacity .35s;
    }
  }
</style>
